module.exports = __webpack_public_path__ + "img/ford-logo-mobile.810bd9cc.png";